import React, { useEffect, useState, useRef } from 'react'
import { message, Drawer, Pagination } from 'antd';

interface Props {
    total: any;
    onRefresh: (pageIndex: any, pageSize: any) => void;
    current: any
    defaultPageSize?: any
}

interface State {
    total: number;
}

const Paging = (props: Props) => {
    // const [pageIndex, setPageIndex] = useState<number>(1);
    const [pageSize, setPageSize] = useState<number>(20);

    useEffect(() => {
        console.log(props.current)
    }, [])



    const render = (
        <Pagination size="small" defaultCurrent={1} current={props.current} total={props.total} defaultPageSize={(props.defaultPageSize) ? props.defaultPageSize : 20} onChange={(index: any, size: any) => {
            console.log(index, size)
            props.onRefresh(index, size)
        }} />
    )

    return render
}

export default Paging
